import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export interface SubNavigationItem {
  to: string;
  label: string;
  icon?: ReactNode;
  end?: boolean;
}

interface SubNavigationProps {
  items: SubNavigationItem[];
  ariaLabel: string;
}

export default function SubNavigation({
  items,
  ariaLabel,
}: SubNavigationProps) {
  return (
    <nav
      aria-label={ariaLabel}
      className="overflow-x-auto rounded-2xl border border-border bg-card p-1.5 shadow-sm"
    >
      <div className="flex min-w-max items-center gap-1">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                "inline-flex min-h-10 items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary",
                isActive
                  ? "bg-brand-primary text-brand-on-brand shadow-sm"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground",
              ].join(" ")
            }
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
